import Vue from 'vue'
import LoadScript from 'vue-plugin-load-script'
import { dateFormat, onlyTime, onlyDate } from 'src/services/filters/date'
import serverError from 'src/services/mixins/serverError'
// import * as zoid from 'zoid/dist/zoid.frameworks.frame.min.js'
import * as zoid from 'src/utils/zoid-override/zoid.frameworks.frame.min.js'

Vue.prototype.$isDev = !!(process.env.DEV || process.env.DEV_FLAG)

window.AtblWidget = zoid.create({
  tag: 'atbl-widget'
})

Vue.use(LoadScript)
Vue.filter('dateFormat', dateFormat)
Vue.filter('onlyTime', onlyTime)
Vue.filter('onlyDate', onlyDate)
Vue.mixin(serverError)
